import React, { useState, useCallback, useEffect, use } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import styled from 'styled-components';
import TopNav from './components/TopNav';
import BookBanner from './components/BookBanner';
import Calendar from './components/Calendar';
import ScheduleList from './components/ScheduleList';
import SectionBanner from './components/SectionBanner';
import BottomTab from './components/BottomTab';
import { NudokPage } from './pages/NudokPage';
import { HomePage } from './pages/HomePage';
import { NupilPage } from './pages/NupilPage';
import MypagePage from './pages/MypagePage';
import RecordCalendarPage from './pages/RecordCalendarPage';
import LoginPage from './pages/LoginPage';
import LoginFormPage from './pages/LoginFormPage';
import SignupPage from './pages/SignupPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import EmailPage from './pages/EmailPage';
import AgreementPage from './pages/AgreementPage';
import TermsDetailPage from './pages/TermsDetailPage';
import KakaoLoginPage from './pages/KakaoLoginPage';
import BookDetailPage from './pages/BookDetailPage';
import NupilBookDetailPage from './pages/NupilBookDetailPage';
import BookSearchPage from './pages/BookSearchPage';
import BookSearchResultPage from './pages/BookSearchResultPage';
import BookRegisterPage from './pages/BookRegisterPage';
import BookDirectRegisterPage from './pages/BookDirectRegisterPage';
import { MyLibraryPage } from './pages/MyLibraryPage';
import BookTimerPage from './pages/BookTimerPage';
import BookRecordPage from './pages/BookRecordPage';
import NupilBookRecordPage from './pages/NupilBookRecordPage';
import SettingsPage from './pages/SettingsPage';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import MoimRecruitPage from './pages/MoimRecruitPage';
import ReviewMoimDetailPage from './pages/ReviewMoimDetailPage';
import { NoobookProvider, useNoobookContext } from './context/NoobookContext';
import BookHistoryPage from './pages/BookHistoryPage';
import MoimDetailPage from './pages/MoimDetailPage';
import MoimCreatePage from './pages/MoimCreatePage';
import NupilBookHistoryPage from './pages/NupilBookHistoryPage';
import BookListRegisterPage from './pages/BookListRegisterPage';
import BookListDetailPage from './pages/BookListDetailPage';
import MyInfoPage from './pages/MyInfoPage';
import MoimMainPage from './pages/MoimMainPage';
import NamecardPage from './pages/NamecardPage';
import MessageListPage from './pages/MessageListPage';
import MessageWritePage from './pages/MessageWritePage';
import MessageChatPage from './pages/MessageChatPage';
import { ApiComm } from './comm/http/ApiComm';
import { AxiosResponse, AxiosError } from 'axios';
import { ResponseDTO } from './dto/ResponseDTO';
import { ERROR_CODES } from './common/errorMessage';
import { clearAccessToken } from './react-queries/queries';
import ScrollRestoration from './components/ScrollRestoration';


// React Query 클라이언트 생성
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const Container = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #eae8e9;
  min-height: 100vh;
  padding: 0;
`;

const TopNavWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 101;
  background: #eae8e9;
`;

const SectionTitle = styled.div`
  font-size: 22px;
  font-weight: bold;
  margin: 24px 0 12px 0;
  padding-left: 8px;
`;

type TabType = 'home' | 'nudok' | 'nupil' | 'moim' | 'mypage' | 'my-library';

interface LogoTextMap {
  [key: string]: string;
}

interface AppProps {
  accessToken: string;
  refreshToken: string;
  isWebview: boolean;
}

let lastSelectedTab: TabType = 'home';

const AppContent: React.FC<AppProps> = ({ accessToken, refreshToken }) => {
  const [selectedTab, setSelectedTab] = useState<TabType>(lastSelectedTab);
  const navigate = useNavigate();
  const location = useLocation();
  const { showBack, setShowBack , logoText, setLogoText } = useNoobookContext();
  
  const onBottomTabChange = useCallback((tab: TabType) => {
    lastSelectedTab = tab;
    setSelectedTab(tab);
    if (tab === 'mypage') {
      navigate('/my-info/records');
    } else {
      navigate(`/${tab}`);
    }
  }, []);


  const logoTextMap: LogoTextMap = {
    home: '누북',
    nudok: '누독',
    nupil: '누필',
    moim: '모임',
    mypage: '내정보',
  };


  useEffect(() => {


    const handleTokenError = (errorCode: number) => {
      switch(errorCode){
        //case ERROR_CODES.UNAUTHORIZATIONERROR:
        case ERROR_CODES.INVALIDTOKEN:
        case ERROR_CODES.EXPIREDTOKEN:
        case ERROR_CODES.INVALIDATEDTOKEN:
          //window.location.href = 'http://192.168.219.105:3000/login';
          //await navigate('/login');
          return true;
      }
      return false;
    };

    const interceptorId = ApiComm.hookResponse((response: AxiosResponse) => {
      console.log("response hook :",response.data, ERROR_CODES.UNAUTHORIZATIONERROR);
      if(handleTokenError(response?.data?.errorCode)){
        //alert('HookResponse: clearAccessToken' + response?.data?.errorCode);
        clearAccessToken();
        if(window.location.pathname !== '/login' && window.location.pathname !== '/') {
          setTimeout(async () => {
          //window.location.href = 'http://192.168.219.105:3000/login';
            await navigate('/login');
          }, 3000);
        }
        return response;
      }
      return response;
    }, (error: AxiosError) => {
      //console.log("error hook error :",error, ERROR_CODES.UNAUTHORIZATIONERROR);
      //handleTokenError(error?.response?.data?.errorCode);
      return error;
    });
    return ()=>{ApiComm.unhookResponse(interceptorId);};
  }, []);
  
  

  useEffect(() => {
    if (location.pathname.startsWith('/home') || location.pathname.startsWith('/nudok') 
      || location.pathname.startsWith('/nupil') || location.pathname.startsWith('/moim') 
      || location.pathname.startsWith('/my-info') ) {
      const tab =  location.pathname.split('/')[1] as TabType;
      if (location.pathname.startsWith('/my-info')) {
        setSelectedTab('mypage');
        setLogoText('내정보');
      } else {
        setSelectedTab(tab);
        setLogoText(logoTextMap[tab] || '');
      }
    } else if (location.pathname.startsWith('/my-library')) {
     // setLogoText('내서재');
    } else if (location.pathname.startsWith('/moim-recruit')) {
     // setLogoText('모임');
    }
  }, [location.pathname]);

  return (
    <Container>
      <TopNavWrapper>
        <TopNav logoText={logoText} showBack={showBack} />
      </TopNavWrapper>
      <Routes>
        <Route path="/home" element={<HomePage />} />
        <Route path="/nudok" element={<NudokPage />} />
        <Route path="/nupil" element={<NupilPage />} />
        <Route path="/moim" element={<MoimMainPage/>} />
        <Route path="/moim-recruit" element={<MoimRecruitPage editBookEventId={null} onClose={null} />} />
        <Route path="/moim-create" element={<MoimCreatePage editBookCommunityId={null} onClose={null} />} />
        <Route path="/moim-detail" element={<MoimDetailPage bookCommunityId={null} onModified={null} />} />
        <Route path="/review-moim-detail" element={<ReviewMoimDetailPage bookEventId={null} />} />
        <Route path="/booklist-register" element={<BookListRegisterPage bookCommunityId={null} bookCommunityBookId={null} onClose={null} />} />
        <Route path="/booklist-detail" element={<BookListDetailPage />} />
        <Route path="/mypage" element={<MypagePage />} />
        <Route path="/my-info/:activeTab" element={<MyInfoPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/namecard" element={<NamecardPage />} />
        <Route path="/messages" element={<MessageListPage />} />
        <Route path="/messages/write" element={<MessageWritePage />} />
        <Route path="/messages/chat" element={<MessageChatPage />} />
        <Route path="/record-calendar/:date" element={<RecordCalendarPage />} />
        <Route path="/book/:bookId" element={<BookDetailPage />} />
        <Route path="/book-nupil/:bookId" element={<NupilBookDetailPage />} />
        <Route path="/book-search" element={<BookSearchPage onClose={null} />} />
        <Route path="/book-search-result" element={<BookSearchResultPage keyword={null} onClose={null} />} />
        <Route path="/book-register" element={<BookRegisterPage propIsbn={null} propBookId={null} onClose={null} />} />
        <Route path="/book-direct-register" element={<BookDirectRegisterPage onClose={null} />} />
        <Route path="/my-library" element={<MyLibraryPage />} />
        <Route path="/book-timer/:pageTimerType/:bookId" element={<BookTimerPage propPageTimerType={null} propBookId={null} onClose={null} />} />
        <Route path="/book-record-nupil/:bookId" element={<NupilBookRecordPage />} />
        <Route path="/book-record/:bookId" element={<BookRecordPage />} />
        <Route path="/book-history/:bookId" element={<BookHistoryPage />} />
        <Route path="/book-history-nupil/:bookId" element={<NupilBookHistoryPage />} />
      </Routes>
      <BottomTab selected={selectedTab} onTabChange={onBottomTabChange} />
    </Container>
  );
};

const App: React.FC<AppProps> = ({ accessToken, refreshToken, isWebview }) => {
  return (
    <NoobookProvider>
      <QueryClientProvider client={queryClient}>
      <AppShell accessToken={accessToken} refreshToken={refreshToken} isWebview={isWebview} />
      </QueryClientProvider>
    </NoobookProvider>
  );
};
const AppShell: React.FC<AppProps> = ({ accessToken, refreshToken, isWebview }) => {
  const { timerStartAt, timerEndAt, timerBookId, timerType } = useNoobookContext();
  const isRunning = timerStartAt && timerEndAt && timerBookId && timerType;
  const startAt = timerStartAt || timerEndAt;
  const endAt = timerEndAt || timerStartAt;
  
  return (
      <Router>
        <ScrollRestoration />
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage isWebview={isWebview} />} />
          <Route path="/login/form" element={<LoginFormPage isWebview={isWebview} />} />
          <Route path="/login/kakao" element={<KakaoLoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/signup/terms" element={<TermsPage />} />
          <Route path="/signup/privacy" element={<PrivacyPage />} />
          <Route path="/signup/email" element={<EmailPage />} />
          <Route path="/signup/agreement" element={<AgreementPage />} />
          <Route path="/terms/:type" element={<TermsDetailPage />} />
          {/*<Route path="/book/:id" element={<BookDetailPage />} />
          <Route path="/book-detail-nupil" element={<BookDetailPageNupil />} />
          <Route path="/book-search" element={<BookSearchPage />} />
          <Route path="/book-search-result" element={<BookSearchResultPage />} />
          <Route path="/book-register" element={<BookRegisterPage onTabChange={onBottomTabChange} />} />
          <Route path="/book-direct-register" element={<BookDirectRegisterPage />} />
          <Route path="/my-library" element={<MyLibraryPage />} />
          <Route path="/book-timer" element={<BookTimerPage />} />
          <Route path="/book-record-nupil" element={<BookRecordPageNupil />} />
          <Route path="/book-record" element={<BookRecordPage />} />*/}
          <Route path="*" element={<AppContent accessToken={accessToken} refreshToken={refreshToken} isWebview={isWebview} />} />
        </Routes>
      </Router>
  );
};

export default App; 